// src/components/watchlist/DeleteConfirmationDialog.js
import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

const DeleteConfirmationDialog = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="delete-dialog-title">
      <DialogTitle id="delete-dialog-title">{t('notifications.confirmDelete')}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{t('notifications.deleteConfirmMessage')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('notifications.cancel')}</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t('notifications.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteConfirmationDialog
